export default {
  name: "Time",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.38 12 12-5.38 12-12 12zm5.93-8.63c-.2.52-.8.76-1.3.56l-5-2A1 1 0 0 1 15 17v-7c0-.55.45-1 1-1s1 .45 1 1v6.32l4.37 1.75c.51.21.76.79.56 1.3z",
  },
}
